import React from 'react';
import { SVGUniqueID } from 'react-svg-unique-id';

const IconGradient = params => {
  const width = params.width || 80;

  return (
    <SVGUniqueID>
      <svg
        viewBox="0 0 892 288"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2">
        <circle cx="1.106" r=".016" fill="url(#_Linear1)" transform="matrix(0 853.826 853.826 0 877.556 -742.862)" />
        <path
          d="M.289-.004c0-.013.004-.026.004-.026a.09.09 0 01.039-.047.093.093 0 01.047-.011c.008 0 .016.002.024.004l.008.003a.087.087 0 01.052.082.089.089 0 01-.09.085.087.087 0 01-.084-.09zm.029.001a.057.057 0 00.056.059A.057.057 0 00.433 0a.058.058 0 00-.056-.059.058.058 0 00-.059.056z"
          fill="url(#_Linear2)"
          fillRule="nonzero"
          transform="scale(853.8258 -853.8258) rotate(-1.833 -4.81 2.302)"
        />
        <path
          d="M.64.085L.642.013a.062.062 0 00-.061-.065.064.064 0 00-.065.061L.514.081.482.08.485.008a.094.094 0 01.097-.092s.037-.001.069.033c.015.017.024.04.023.065L.672.086.64.085z"
          fill="url(#_Linear3)"
          fillRule="nonzero"
          transform="scale(853.8258 -853.8258) rotate(-1.833 -4.71 2.3)"
        />
        <path
          d="M.232.127L.234.054a.063.063 0 00-.061-.065.063.063 0 00-.065.061L.106.122.074.121.076.049a.096.096 0 01.098-.092s.032-.001.062.026v-.011a.062.062 0 00-.061-.065.062.062 0 00-.063.05L.08-.044a.093.093 0 01.096-.081s.037-.001.069.032a.097.097 0 01.023.066L.266.045v.01L.264.128.232.127z"
          fill="url(#_Linear4)"
          fillRule="nonzero"
          transform="scale(853.8258 -853.8258) rotate(-1.833 -6.407 2.327)"
        />
        <path
          d="M1.016.127l.003-.073a.063.063 0 00-.061-.065.063.063 0 00-.065.061L.891.111.859.11.861.049a.095.095 0 01.097-.092s.033-.001.063.026v-.011A.063.063 0 00.96-.093a.063.063 0 00-.064.05L.864-.044a.095.095 0 01.061-.075.085.085 0 01.036-.006s.037-.001.069.032a.097.097 0 01.023.066l-.002.072H1.05l.001.01-.003.073-.032-.001z"
          fill="url(#_Linear5)"
          fillRule="nonzero"
          transform="scale(853.8258 -853.8258) rotate(-1.833 -5.675 2.316)"
        />
        <path
          d="M.773.123L.765.12A.09.09 0 01.711.038l.005-.166.032.001-.005.135.071.002-.001.031-.07-.002a.058.058 0 00.056.06.057.057 0 00.059-.056V.042L.89.043v.001C.89.057.886.07.886.07a.094.094 0 01-.088.057H.797A.067.067 0 01.773.123z"
          fill="url(#_Linear6)"
          fillRule="nonzero"
          transform="scale(853.8258 -853.8258) rotate(-1.833 -3.215 2.276)"
        />
        <defs>
          <linearGradient
            id="_Linear1"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="scale(1 -1) rotate(-88.167 1.106 0)">
            <stop offset="0" stopColor="#7b23e2" />
            <stop offset="1" stopColor="#4c96b4" />
          </linearGradient>
          <linearGradient id="_Linear2" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(1 0 0 -1 0 -.001)">
            <stop offset="0" stopColor="#7b23e2" />
            <stop offset="1" stopColor="#4c96b4" />
          </linearGradient>
          <linearGradient id="_Linear3" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(1 0 0 -1 0 .001)">
            <stop offset="0" stopColor="#7b23e2" />
            <stop offset="1" stopColor="#4c96b4" />
          </linearGradient>
          <linearGradient id="_Linear4" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(1 0 0 -1 0 .001)">
            <stop offset="0" stopColor="#7b23e2" />
            <stop offset="1" stopColor="#4c96b4" />
          </linearGradient>
          <linearGradient id="_Linear5" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(1 0 0 -1 0 .001)">
            <stop offset="0" stopColor="#7b23e2" />
            <stop offset="1" stopColor="#4c96b4" />
          </linearGradient>
          <linearGradient id="_Linear6" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(1 0 0 -1 0 0)">
            <stop offset="0" stopColor="#7b23e2" />
            <stop offset="1" stopColor="#4c96b4" />
          </linearGradient>
        </defs>
      </svg>
    </SVGUniqueID>
  );
};

export default IconGradient;
